module.exports = __webpack_public_path__ + "static/media/tmdblogo.86ff7c17.svg";